// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import LetterComments from 'components/letter/LetterComments/LetterComments';
import LetterCommentInput from 'components/letter/LetterCommentInput/LetterCommentInput';
import { LettersActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/letters';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  letterId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class LetterCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    LettersActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    LettersActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { letterId, removeComment } = this.props;
    if (!letterId || !removeComment.commentId) return;
    LettersActions.removeComment({
      letterId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { letterId } = this.props;
    if (!letterId) return Promise.resolve();
    return LettersActions.editComment({
      letterId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { letterId } = this.props;
    if (!letterId) return Promise.resolve();
    let comment = null;
    try {
      comment = await LettersActions.writeComment({
        letterId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await LettersActions.readComments({ letterId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { letterId, shouldCancel } = this.props;
    if (!letterId) return;
    try {
      if (shouldCancel) return;
      await LettersActions.readComments({ letterId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.letterId !== this.props.letterId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { letterId } = this.props;
    if (!letterId) return Promise.resolve(null);
    return LettersActions.readSubComments({
      letterId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <LetterComments
          logged={logged}
          commentInput={logged && <LetterCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="뉴스레터 댓글 삭제"
          description="이 뉴스레터 댓글을 정말로 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    letterId: state.letters.letter && state.letters.letter.id,
    comments: state.letters.comments,
    subCommentsMap: state.letters.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.letters.letter || state.pender.pending['letters/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.letters.removeComment,
    commentsCount: state.letters.letter && state.letters.letter.comments_count,
  }),
  () => ({}),
)(withRouter(LetterCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/letter/LetterCommentsContainer.js